<template>
  <div class="datepicker" v-if="can_edit">
    <datepicker
      ref="sourceDatePicker"
      :input-class="this.input_class"
      :format="this.input_format"
      :value="this.input_value"
      :monday-first="true"
      @selected="onSelected()"
    ></datepicker>
    <datepicker
      ref="targetDatePicker"
      :input-class="this.target.class"
      :name="this.input_name"
      :format="this.target.format"
      v-model="this.target.value"
    ></datepicker>
  </div>
  <div class="datepicker" v-else>
    <datepicker
        disabled="disabled"
        ref="sourceDatePicker"
        :input-class="this.input_class"
        :format="this.input_format"
        :value="this.input_value"
        :monday-first="true"
        @selected="onSelected()"
    ></datepicker>
    <datepicker
        ref="targetDatePicker"
        :input-class="this.target.class"
        :name="this.input_name"
        :format="this.target.format"
        v-model="this.target.value"
    ></datepicker>
  </div>

</template>



<script>
  import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
  import * as lang from "vuejs-datepicker/src/locale";

  const state = {
    date1: new Date()
  };

  export default {
    name: "app",
    components: {
      Datepicker
    },
    data()  {
        return {
            source: {
              value: ""
            },
            target: {
              class: "hidden",
              format: "yyyy-MM-dd",
              value: "",
            },
            label_date : null
        }
    },
    mounted() {
      this.setDateToTarget(this.$refs.sourceDatePicker.$data.selectedDate);

    },
    methods: {
      onSelected() {
        this.setDateToTarget(this.$refs.sourceDatePicker.$data.selectedDate)
      },
      setDateToTarget(currentDate) {
        this.target.value = currentDate
      },
    },

    watch: {
      input_value: {
        handler: function(val) {
          this.setDateToTarget(val)
        },
        deep: true
      }
    },

    props: {
      input_class: {
        type: String,
        default: ""
      },
      input_name: {
        type: String,
        required: true
      },
      input_format: {
        type: String,
        default: "dd/MM/yyyy"
      },
      input_value: {
        type: String,
      },
      can_edit: {
        type: Boolean,
        default: true
      },
    }
  }
</script>
